import React from "react"
import { T, always, cond, pathOr } from "ramda"
import { Theme } from "@pga/pga-component-library"
import moment from "moment"

import { PDRTracking } from "./ProgressBar"
import { Condition, TotalWrapper, Wrapper } from "./Styles/Shared.styles"
import { formatDate } from "../../utils/formatter"
import AlertBox from "./AlertBox"
import { getPdrRequirementNotice, isGateCohort } from "./utils"

const NewPDRInfo = ({ currentPerson }) => {
  const { firstName, pdrRequirements } = currentPerson
  const { cycleCode, cycleEndsOn } = pathOr(
    {},
    ["pdrRequirements"],
    currentPerson,
  )
  const requirements = pathOr([], ["requirements"], pdrRequirements)
  const status = pathOr(null, ["status"], pdrRequirements)
  const cohortCode = pathOr(null, ["cohortCode"], pdrRequirements)
  const notice = getPdrRequirementNotice(currentPerson)
  const isGate = isGateCohort(cohortCode)
  const isLmGate = cohortCode === "LM"
  const fourMonthsBeforeEndOfCycle = cycleEndsOn
    ? moment(cycleEndsOn).subtract(4, "months").toDate()
    : null
  const today = moment().startOf("day")
  const cycleEndFormatted = formatDate(cycleEndsOn, "MMMM DD")

  const greeting = cond([
    [
      status => status === "requirements_met" && isLmGate,
      always(
        "You have met your remaining PDR requirements and are eligible to transfer to an active classification.",
      ),
    ],
    [
      status => status === "requirements_not_met" && isLmGate,
      always(
        "You must meet your remaining PDR requirements if you want to transfer to an active classification.",
      ),
    ],
    [
      status => status === "requirements_met",
      always(
        `Congrats, ${firstName}! You've met your PDR requirements for this cycle.`,
      ),
    ],
    [
      T,
      always('Earn more credits by clicking the "Earn Credits" button below.'),
    ],
  ])

  const message = cond([
    [
      status => status === "recovering" && !isGate,
      always(
        `Report all recovery credits for Cycle ${cycleCode} by ${cycleEndFormatted} to avoid being dropped from active Membership rolls.`,
      ),
    ],
    [
      status => status === "requirements_not_met" && !isGate,
      always(
        `Report credits earned in PDR Cycle ${cycleCode} by ${cycleEndFormatted} to avoid reclassification to Class F.`,
      ),
    ],
    [T, always(null)],
  ])

  const footerCopy =
    isLmGate || notice
      ? null
      : "Requirements in all categories must be met to maintain membership."

  const showAlertBox =
    !isGate &&
    moment(fourMonthsBeforeEndOfCycle).isBefore(today) &&
    message(status)

  return (
    <>
      <TotalWrapper>{notice ? notice.message : greeting(status)}</TotalWrapper>
      {showAlertBox ? <AlertBox>{message(status)}</AlertBox> : null}
      <div>
        <Wrapper>
          {requirements.map((pdr, i) => (
            <PDRTracking
              completed={pdr.earned}
              total={pdr.totalRequirement}
              label={pdr.label}
              color={
                [
                  Theme.colors.lightBlue,
                  Theme.colors.gold,
                  Theme.colors.primary,
                ][i]
              }
              recovery={isGate ? 0 : pdr.recoveryRemaining}
              totalDeficit={isGate ? 0 : pdr.recoveryRemaining}
              hideRecovery={isGate}
              key={i}
            />
          ))}
        </Wrapper>
        {footerCopy ? <Condition>{footerCopy}</Condition> : null}
      </div>
    </>
  )
}

export default NewPDRInfo
